import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/client/$accountId/exchanges/$exchangeId/summary`,
      params: {
        accountId: params.accountId,
        exchangeId: params.exchangeId,
      },
      replace: true,
    });
  },
});
